import { render, staticRenderFns } from "./SalesEvolutionTable.vue?vue&type=template&id=47c23b2b&scoped=true&"
import script from "./SalesEvolutionTable.vue?vue&type=script&lang=js&"
export * from "./SalesEvolutionTable.vue?vue&type=script&lang=js&"
import style0 from "./SalesEvolutionTable.vue?vue&type=style&index=0&id=47c23b2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c23b2b",
  null
  
)

export default component.exports